import Duck from 'custom-redux-ducks-ts'

export const applications = new Duck('applications', 'eduprivada')
